import type { ApiDataTransformer } from '@kiplin/web-common/architecture-core';
import { injectable } from 'inversify';

@injectable()
export class ToFormDataApiDataTransformer<From> implements ApiDataTransformer<From, FormData> {
  public map(data: From): FormData {
    const formData = new FormData();

    for (const key in data) {
      const value = data[key];
      if (value === undefined) {
        continue;
      }

      if (value instanceof File || value instanceof Blob) {
        formData.append(String(key), value);
        continue;
      }

      if (value instanceof Date) {
        formData.append(String(key), value.toISOString());
        continue;
      }

      if (typeof value === 'boolean') {
        formData.append(String(key), value ? 'true' : 'false');
        continue;
      }

      if (typeof value === 'object') {
        // Includes `null` (sent as "null") to support explicit deletion in multipart payloads.
        formData.append(String(key), JSON.stringify(value));
        continue;
      }

      formData.append(String(key), String(value));
    }

    return formData;
  }
}
